import {
  BILLING_MODELS,
  CONTRACT_STATUSES,
  type BillingModel,
  type ContractStatus,
} from '@/shared/api/billing';

/**
 * `validateSearch` of `/billing/contracts` (`AM-350`): every filter lives in the URL, so a link opens the
 * list already narrowed ("Ver todos los contratos" in the file of a customer) and back and forward keep
 * what the reader chose. A value the list does not know is dropped, never thrown on.
 */
export interface ContractsSearch {
  search?: string;
  status?: ContractStatus;
  billingModel?: BillingModel;
  organizationId?: string;
}

export function contractsSearchSchema(search: Record<string, unknown>): ContractsSearch {
  const result: ContractsSearch = {};

  const text = search['search'];
  if (typeof text === 'string' && text.trim().length > 0) {
    result.search = text;
  }

  const status = search['status'];
  if (typeof status === 'string' && CONTRACT_STATUSES.includes(status as ContractStatus)) {
    result.status = status as ContractStatus;
  }

  const billingModel = search['billingModel'];
  if (typeof billingModel === 'string' && BILLING_MODELS.includes(billingModel as BillingModel)) {
    result.billingModel = billingModel as BillingModel;
  }

  const organizationId = search['organizationId'];
  if (typeof organizationId === 'string' && organizationId.length > 0) {
    result.organizationId = organizationId;
  }

  return result;
}
